var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 2.04761V4.04761",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 2.04761V4.04761",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 3.04761C12.8867 3.16761 14 4.01427 14 7.14761V11.2676C14 14.0143 13.3333 15.3876 10 15.3876H6C2.66667 15.3876 2 14.0143 2 11.2676V7.14761C2 4.01427 3.11333 3.17427 5.33333 3.04761H10.6667Z",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8333 12.4476H2.16667",
    stroke: "#1F2A37",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 6.21429C7.17999 6.21429 6.48666 6.66096 6.48666 7.52763C6.48666 7.94096 6.67999 8.25429 6.97333 8.45429C6.56666 8.69429 6.33333 9.08096 6.33333 9.53429C6.33333 10.361 6.96666 10.8743 7.99999 10.8743C9.02666 10.8743 9.66666 10.361 9.66666 9.53429C9.66666 9.08096 9.43333 8.68763 9.01999 8.45429C9.31999 8.24763 9.50666 7.94096 9.50666 7.52763C9.50666 6.66096 8.81999 6.21429 7.99999 6.21429ZM7.99999 8.10763C7.65333 8.10763 7.4 7.90096 7.4 7.57429C7.4 7.24096 7.65333 7.04763 7.99999 7.04763C8.34666 7.04763 8.59999 7.24096 8.59999 7.57429C8.59999 7.90096 8.34666 8.10763 7.99999 8.10763ZM7.99999 10.0476C7.55999 10.0476 7.23999 9.82763 7.23999 9.42763C7.23999 9.02763 7.55999 8.81429 7.99999 8.81429C8.43999 8.81429 8.75999 9.03429 8.75999 9.42763C8.75999 9.82763 8.43999 10.0476 7.99999 10.0476Z",
    fill: "#1F2A37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.e9430948f8b22b08865fea19b706d254.svg";
export { ForwardRef as ReactComponent };